<script>
	// external libraries
	import { Styles } from "sveltestrap";
	// app import
	import DupoApp from "./DupoApp.svelte";
	import Global from "./global.svelte";
</script>

<Styles />
<svelte:head>
	<title>Dupo</title>
	<link rel="icon" type="image/png" href="image/dupo-icon-2.png" />
	<link rel="stylesheet" href="data/bootstrap-icons.css" />
	<script
		async
		src="https://cdn.jsdelivr.net/pyodide/v0.21.3/full/pyodide.js"
	></script>
</svelte:head>
<Global />
<header id="dupo-toggle" class="dupo-toggle">
	<div class="dupo-header-wrap">
		<img
			src="image/dupo-icon-2.png"
			style="width: 22px; height: 22px;"
			alt="Dupo icon"
		/>
	</div>
</header>

<main class={`container-fluid px-0 dupo`}>
	<DupoApp />
</main>

<style>
	header {
		height: 41px;
	}

	main {
		height: calc(100vh - 78px);
	}
	main.dupo {
		height: calc(100vh - 32px);
	}

	header.dupo-toggle {
		width: 100%;
		height: 32px;
		padding: 5px;
		background-color: #f5f5f5;
		border-bottom: 1px solid #dddddd;
	}
	.dupo-header-wrap {
		line-height: 100%;
		padding-left: 4px;
		display: flex;
		justify-content: space-between;
	}
</style>
